module.exports = __webpack_public_path__ + "media/images/Banner_PCH_780x520-2e5dd6d1c96794ee40ec9736748f53b6.jpg";